import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'TransactionDirection';
const ENDPOINT = `/transaction-directions/`;

@Injectable({
    providedIn: 'root'
})
export class TransactionDirectionService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
